import { Typography, Stack, IconButton, Divider, Link, Box } from '@mui/material'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'

import { type StepKey } from '../AudioPromptWizard'

export function Header(props: { title: string; onClose: () => void }) {
  const { title, onClose } = props

  return (
    <Stack direction="row" gap="16px" justifyContent="space-between" padding="24px 24px 20px 24px">
      <Typography sx={{ fontSize: 18, fontWeight: 600, lineHeight: '28px' }}>{title}</Typography>
      <IconButton size="small" onClick={onClose}>
        <CloseRoundedIcon />
      </IconButton>
    </Stack>
  )
}

interface TranscriptPreviewProps {
  transcript: string
  maxLength?: number
  navigateTo: (step: StepKey) => void
}

export function TranscriptPreview({ transcript, maxLength = 200, navigateTo }: TranscriptPreviewProps) {
  const truncatedText = transcript.length > maxLength ? transcript.slice(0, maxLength) + '…' : transcript

  return (
    <Stack className="Transcript" direction="row" gap="10px">
      <Box bgcolor="#D0D5DD" height="auto" width="3px" />
      <Typography color="#667085" fontSize={12} lineHeight="18px">
        {truncatedText}
        {'  '}
        <Link
          component="button"
          sx={{ color: '#D81B60', fontWeight: 'medium' }}
          underline="none"
          onClick={() => {
            navigateTo('transcript')
          }}
        >
          View transcript
        </Link>
      </Typography>
    </Stack>
  )
}
